import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import {
  loadOrganozationsRequestAction,
  updateOrganizationStartedAction,
  updateOrganizationEndAction,
  clearFilterAction,
  setFilterAction,
  changePageAction,
} from '@actions/organizations';
import {
  selectOrganizationsList,
  selectOrganizationsListIsFetching,
  selectOrganizationsFilter,
} from '@selectors/organizations';
import OrganizationsPage from './OrganizationsPage';

const mapStateToProps = (state) => ({
  list: selectOrganizationsList(state),
  isFetching: selectOrganizationsListIsFetching(state),
  filter: selectOrganizationsFilter(state),
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      loadOrganozationsList: loadOrganozationsRequestAction,
      updateOrganizationStarted: updateOrganizationStartedAction,
      updateOrganizationEnd: updateOrganizationEndAction,
      clearFilter: clearFilterAction,
      setFilterField: setFilterAction,
      changePage: changePageAction,
    },
    dispatch,
  ),
  goToEditPage: ({ id }) => dispatch(push(`/organization/edit/${id}`)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizationsPage);



// WEBPACK FOOTER //
// ./components/pages/OrganizationsPage/index.js